/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
export const getActiveLocale = (locale?: string): string => {
  return locale || (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
};
